
<div class="boot_session">
    <div class="botdetails">
        <div class="closebtn">
            <i (click)="openbot()" class="fa fa-times" aria-hidden="true"></i>
        </div>
    <iframe class="boots" src="https://aps-chatbot-ui-dev.azurewebsites.net/chatbot" frameborder="0">
        
    </iframe>
    </div>
    <div class="botdisplay " (click)="openbot()" >
      <img src="/assets/image/icons/assistant.png" width="100%" height="100%">
    </div>
</div>
